export type HostingPleskSiteStatusKind = 'ACTIVE' | 'INACTIVE' | 'MAINTENANCE' | 'UNKNOWN';
/** Codes cumulables de siteGenInfoType (API XML Plesk). Une valeur absente ou
 * un bit inconnu ne devient jamais « actif ». Le bit 4 seul désigne une opération
 * de sauvegarde/restauration temporaire, pas une désactivation administrative. */
export class HostingPleskSiteStatus {
  public readonly kind: HostingPleskSiteStatusKind;
  public constructor(code: string | null | undefined) {
    if (typeof code !== 'string' || !/^[0-9]{1,10}$/u.test(code)) {
      this.kind = 'UNKNOWN';
      return;
    }
    const value = BigInt(code);
    const known = 1n | 2n | 4n | 8n | 16n | 32n | 64n | 256n;
    this.kind =
      (value & ~known) !== 0n
        ? 'UNKNOWN'
        : value === 0n
          ? 'ACTIVE'
          : value === 4n
            ? 'MAINTENANCE'
            : 'INACTIVE';
  }
}
